import { render } from "./CoverSelect.vue?vue&type=template&id=ad62b2d2"
import script from "./CoverSelect.vue?vue&type=script&lang=js"
export * from "./CoverSelect.vue?vue&type=script&lang=js"

import "./CoverSelect.vue?vue&type=style&index=0&id=ad62b2d2&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__